import socketIOClient from "socket.io-client";
import { SOCKETURL } from "../contants";

// Single socket connection shared by the redux middleware (sending) and
// useKitchenDisplay (receiving). Two connections meant every broadcast was
// downloaded twice, which hurts most on slow mobile networks.
const socket = socketIOClient(SOCKETURL, {
 // Skip the long-polling handshake when websockets work; fall back if not.
 transports: ["websocket", "polling"],
 tryAllTransports: true,
 reconnection: true,
 reconnectionDelay: 1000,
 reconnectionDelayMax: 5000,
});

const joinedRooms = new Set();

socket.on("disconnect", () => {
 // Server drops room membership on disconnect, so rejoin after reconnect.
 joinedRooms.clear();
});

export const ensureRoomsJoined = (channels) => {
 if (!socket.connected) return;
 channels.forEach((channel) => {
   if (!channel) return;
   const room = channel.toString();
   if (!joinedRooms.has(room)) {
     socket.emit("JOIN_ROOM", room);
     joinedRooms.add(room);
   }
 });
};

export default socket;

